import { render, staticRenderFns } from "./SendMessageToPatient.vue?vue&type=template&id=5023f727&scoped=true"
import script from "./SendMessageToPatient.vue?vue&type=script&lang=js"
export * from "./SendMessageToPatient.vue?vue&type=script&lang=js"
import style0 from "./SendMessageToPatient.vue?vue&type=style&index=0&id=5023f727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5023f727",
  null
  
)

export default component.exports